import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import { useTranslation } from "react-i18next";

import { IFeeBreakdownSettled } from "../../../../setup/api/services/contract/models";
import { ShippingFeeBreakdownState } from "./shippingFeeHelpers";

import styles from "./deliveryFeeModal.module.scss";

interface Props {
  state: ShippingFeeBreakdownState;
  settled: IFeeBreakdownSettled | null;
}

const FeeBreakdownSection = ({ state, settled }: Props) => {
  const { t } = useTranslation();

  const formatAmount = (amount: number) =>
    `${amount.toFixed(2)} ${t("lbl_saudi_currency")}`;

  const showBreakdown = state === "final" && settled != null;

  return (
    <div className={styles.feeBreakdownWrap} data-state={state}>
      {showBreakdown ? (
        <div className={styles.feeBreakdown}>
          <h4 className={styles.feeBreakdownTitle}>
            {t("lbl_shipping_fee_breakdown_title")}
          </h4>
          <div className={styles.feeBreakdownRow}>
            <span className={styles.feeBreakdownLabel}>
              {t("lbl_shipping_fee_actual_cost")}
            </span>
            <span className={styles.feeBreakdownValue} dir="ltr">
              {formatAmount(settled.actualShippingCost ?? 0)}
            </span>
          </div>
          <div className={styles.feeBreakdownRow}>
            <span className={styles.feeBreakdownLabel}>
              {t("lbl_shipping_fee_waffy_percentage")}
              {settled.waffyPercentage != null && (
                <span className={styles.feeBreakdownLabelPercent}>
                  ({settled.waffyPercentage}%)
                </span>
              )}
            </span>
            <span className={styles.feeBreakdownValueProfit} dir="ltr">
              {formatAmount(settled.waffyProfit ?? 0)}
            </span>
          </div>
          <div className={styles.feeBreakdownRowTotal}>
            <span className={styles.feeBreakdownLabel}>{t("lbl_total")}</span>
            <span className={styles.feeBreakdownValue} dir="ltr">
              {formatAmount(settled.amount ?? 0)}
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.feeBreakdownEmpty}>
          <div className={styles.feeBreakdownEmptyIcon}>
            <ScheduleOutlinedIcon />
          </div>
          <p className={styles.feeBreakdownEmptyTitle}>
            {t("lbl_shipping_fee_breakdown_empty_title")}
          </p>
          <p className={styles.feeBreakdownEmptyDesc}>
            {t("lbl_shipping_fee_breakdown_empty_desc")}
          </p>
        </div>
      )}
    </div>
  );
};

export default FeeBreakdownSection;
